var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { api } from "../../../api/API";
import { EditAddressTemplate } from "../../settings/companies/clients/client/EditAddressTemplate";
import { jsx as _jsx } from "react/jsx-runtime";
export function AddressManageSupplier(props) {
    return /*#__PURE__*/ _jsx(EditAddressTemplate, { title: "Company Address", street: props.value.addressStreet || "", city: props.value.addressCity || "", province: props.value.addressProvince || "", postal: props.value.addressPostal || "", onClose: props.onClose, onUpdate: (input) => __awaiter(this, void 0, void 0, function* () {
            const id = props.value.manufacturer;
            if (!id)
                throw new Error("invalid manufacturer id");
            const co = yield api.companies.get({ id: id });
            yield api.companies.upsert(Object.assign({}, co, { addressStreet: input.street, addressCity: input.city, addressProvince: input.province, addressPostal: input.postal })); // trigger reload
            return props.onUpdate(Object.assign({}, props.value));
        }) });
}
